import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { appRoutes } from '@app/configs/route-paths-const.config';
import { subscriptionStatusEnum } from '@app/modules/shared/models/user-plan-detail.model';
import { JWTAuthService } from './jwt-auth.service';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(public auth: JWTAuthService, public router: Router) { }
  canActivate(): boolean {
    let userSubs = this.auth.getUserSubscription();
    if (!this.auth.IsAuthUser()) {
      this.router.navigate([appRoutes.login]);
      return false;
    }
    else if (userSubs == subscriptionStatusEnum.none) {
      this.router.navigate([appRoutes.choosePlan]);
      return false;
    }
    return true;
  }
}